/* LEDPLANET keuzehulp sneller laden (20-10-2026, thema 2.7.9). Geladen vóór assets/lp-keuzehulp.js (snippets/ledplanet-keuzehulp).
   1. Alle datapagina's (?view=keuzehulp-data&page=N) tegelijk ophalen i.p.v. na elkaar: het aantal pagina's volgt uit
      data-aantal (aantal producten, 250 per pagina); zekerheidshalve start na pagina 1 ook nog wat er dan nog ontbreekt (max. 12). lp-keuzehulp.js vraagt ze daarna nog steeds één voor één op,
      maar krijgt ze dan meteen uit dit geheugen.
   2. Vooraf laden: wijst de bezoeker de knop "Help mij kiezen" aan, raakt hij hem aan of komt hij er met tab op,
      dan starten de data en het tekstbestand al, zodat alles er bij het klikken meestal al is. */
(function () {
  'use strict';
  if (window.LPKH_SNEL || !window.fetch) return;
  window.LPKH_SNEL = 1;
  var root = document.querySelector('[data-lpkh]');
  if (!root) return;
  var echt = window.fetch.bind(window);
  var GEHEUGEN = {};                          // volledige url -> Promise<{status, tekst}>
  function sleutel(u) { try { return new URL(u, location.href).href; } catch (e) { return String(u); } }
  function isData(u) { return /[?&]view=keuzehulp-data(&|$)/.test(u) && /[?&]page=\d+/.test(u); }
  function zetPagina(u, n) { return u.replace(/([?&]page=)\d+/, '$1' + n); }
  function haal(u) {
    var k = sleutel(u);
    if (!GEHEUGEN[k]) {
      GEHEUGEN[k] = echt(k, { credentials: 'same-origin' }).then(function (r) {
        return r.text().then(function (t) { return { status: r.status, tekst: t }; });
      });
      GEHEUGEN[k].then(function (x) { if (x.status !== 200) delete GEHEUGEN[k]; }, function () { delete GEHEUGEN[k]; });
      if (/[?&]page=1(&|$)/.test(k)) {
        // aantal pagina's is al bekend uit het aantal producten (data-aantal): alle pagina's direct tegelijk starten
        var aantal = +root.getAttribute('data-aantal') || 0;
        if (aantal > 250) for (var p = 2; p <= Math.min(Math.ceil(aantal / 250), 12); p++) haal(zetPagina(k, p));
        GEHEUGEN[k].then(function (x) {
          if (x.status !== 200) return;
          var j; try { j = JSON.parse(x.tekst); } catch (e) { return; }
          var tot = Math.min(+j.pages || 1, 12);
          for (var n = 2; n <= tot; n++) haal(zetPagina(k, n));
        }).catch(function () {});
      }
    }
    return GEHEUGEN[k];
  }
  window.fetch = function (u, o) {
    var s = typeof u === 'string' ? u : (u && u.url) || '';
    if (s && isData(s) && (!o || !o.method || o.method === 'GET')) {
      return haal(s).then(function (x) { return new Response(x.tekst, { status: x.status, headers: { 'Content-Type': 'application/json' } }); });
    }
    return echt.apply(window, arguments);
  };
  function dataUrl(basis) { return basis + (basis.indexOf('?') === -1 ? '?' : '&') + 'view=keuzehulp-data&page=1'; }
  var gestart = false;
  function vooraf() {
    if (gestart) return; gestart = true;
    var basis = (root.getAttribute('data-basis') || '').replace(/\/$/, '');
    var coll = root.getAttribute('data-url') || location.pathname;
    haal(dataUrl(coll));
    if (basis && coll.indexOf(basis + '/') === 0) haal(dataUrl(coll.slice(basis.length)));   // andere taal: ook de Nederlandse data
    var tx = root.getAttribute('data-tekst');
    if (tx && !document.querySelector('script[data-lpkh-tx]')) {
      var taal = (root.getAttribute('data-taal') || 'nl').slice(0, 2).toLowerCase();
      if (!(window.LPKH_TX && window.LPKH_TX[taal])) { var sc = document.createElement('script'); sc.src = tx; sc.async = true; sc.setAttribute('data-lpkh-tx', '1'); document.head.appendChild(sc); }
    }
  }
  function opKnop(e) { if (e.target && e.target.closest && e.target.closest('.lpkh-start, [data-lpkh-open]')) vooraf(); }
  document.addEventListener('pointerover', opKnop, { passive: true });
  document.addEventListener('touchstart', opKnop, { passive: true });
  document.addEventListener('focusin', opKnop);
})();
